import { ReactNode } from 'react';
import _ from 'lodash';
import { IWidgetClass, IWidgetDescription } from '@UI/Widgets/WidgetStructs';
import { helperRenderMarkdown, MarkdownProps } from '@Primitive/Markdown/MarkdownLazy';
// =================================================================================================
export interface BlankData { }
// =================================================================================================
export class BlankWidget extends IWidgetClass<BlankData> {
    Render(key: string, width: number, height: number): ReactNode {
        return <div style={{ width, height }}></div>;
    }
    // ---------------------------------------------------------------------------------------------
    // Empty functions
    RenderToolbar(key: string, toolbarHeight: number) { return null; }
    ToolbarDynamicTooltip() { return null; }
    RenderWidgetSettings(key: string, width: number, height: number) { return null; }
    WidgetDataUpdate(data) { }
    GetDefaultValues() { return {} }
    ValidateValues(key, value) { return { valid: true, errors: null } }
    GetLocalizationDictionary() { return null; }
    UpdateLocalization() { }
    MigrateDefaultWidgetData(data) { return data }
    RenderBase(key: string, width: number, height: number) { return this.Render(key, width, height); }
    RenderBaseToolbar(key: string, toolbarHeight: number) { return null; }
    RenderBaseSettings(key, width, height) { return null; }
    GetDefaultWidgetDataStatic(): BlankData { return {}; }
    GetLocalizedWidgetTitle() { return null; }
    GetDataPortKeyStatic() { return null; }
    // ---------------------------------------------------------------------------------------------
    public RenderDescription(key: string, width: number, height: number, markdownProps: MarkdownProps = {}) {
        return helperRenderMarkdown("", { key: key, width: width, height: height, ...markdownProps });
    }
    // ---------------------------------------------------------------------------------------------
    public GetDefaultWidgetData() { return this.GetDefaultWidgetDataStatic(); }
    // ---------------------------------------------------------------------------------------------
    public GetWidgetDesc(): IWidgetDescription { return BlankWidget.GetWidgetDesc(); }
    // ---------------------------------------------------------------------------------------------
    public static GetWidgetDesc(): IWidgetDescription {
        // TODO: Update the widget Description
        return {
            Title: 'Blank',
            WidgetTitle: '',
            Key: 'BlankWidget',
            Type: 'BlankWidget',
            Data: {},
            MinH: 1,
            MinW: 1,
            ShowExtraMenu: false,
            WidgetNoBackground: true,
            IconURI: null
        };
    }
    // ---------------------------------------------------------------------------------------------
}